// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import AvatarUploaderController from "./avatar_uploader_controller"
application.register("avatar-uploader", AvatarUploaderController)

import ImageViewerController from "./image_viewer_controller"
application.register("image-viewer", ImageViewerController)

import PhotoSwipeController from "./photoswipe_controller"
application.register("photoswipe", PhotoSwipeController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)

import ApexChartController from "./apex_chart_controller"
application.register("apex-chart", ApexChartController)

import WxMiniProgramController from "./wx_mini_program_controller"
application.register("wx-mini-program", WxMiniProgramController)

import LoadingOverlayController from "./loading_overlay_controller"
application.register("loading-overlay", LoadingOverlayController)
